import { render } from "./AfterTest.vue?vue&type=template&id=79ef829d&scoped=true"
import script from "./AfterTest.vue?vue&type=script&lang=js"
export * from "./AfterTest.vue?vue&type=script&lang=js"

import "./AfterTest.vue?vue&type=style&index=0&id=79ef829d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ef829d"]])

export default __exports__